import { render, staticRenderFns } from "./statistics-manager.vue?vue&type=template&id=3715fdc4&"
import script from "./statistics-manager.vue?vue&type=script&lang=js&"
export * from "./statistics-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports